<template>
  <div >
    <a-back-top />
    <a-row>
      <a-col :md="24">
        <div class="allbody" :style="{transform : `scale(${scaleW},${scaleH})`}">
<!--          <div style="float: left;margin-top: 1%;margin-left: 10%">
            <img src="~@/assets/imgs/logo1.png" width="40">
          </div>-->
          <div style="margin-top: 1%;float: right;margin-right: 15%;">
            <router-link to='/'><a>首页</a></router-link>
            <router-link to='/productintr'><a style="font-weight: bold;">产品介绍</a></router-link>
            <router-link to='/aboutus'><a>关于我们</a></router-link>
            <router-link to='/caseinfo'><a>业绩案例</a></router-link>
            <router-link to='/contantus'><a-button shape="round">联系我们</a-button></router-link>
          </div>
<!--          <div class="contant">
            <p style="color: rgba(255, 255, 255, 100);font-size: 26px;font-weight: bold">
              <span>以人为本，以高新技术服务于社会</span>
            </p>
            <p style="color: rgba(255, 255, 255, 100);font-size: 16px;">
              <span>公司集研发、生产、销售与服务于一体，本着“以人为本，以高新技<br/>术服务于社会”的理念经营发展公司</span>
            </p>
          </div>-->
        </div>
      </a-col>
      <a-col :md="24">
        <div style="text-align: center;">
          <a-tabs default-active-key="1" animated :tabBarGutter="tabBarGutter" style="height: 350px">
            <a-tab-pane key="1" tab="电梯管理系统">
              <a-row>
                <a-col :md="14">
                  <div style="width: 80%;float: right;padding-top: 8%;text-align: center">
                    <p style="color: #404040;font-size: 28px;font-family: SourceHanSansSC-regular;font-weight: bold">电梯管理系统</p>
                      <p style="color:#233D63;font-size: 20px;">围绕电梯服务管理场景，提供智能设备、远程监测与信息化平台等相关能力。</p>
                  </div>
                </a-col>
                <a-col :md="8">
                  <img src="~@/assets/imgs/cmwlwv.png" width="320" style="margin-top: 2%;"/>
                </a-col>
              </a-row>
            </a-tab-pane>
            <a-tab-pane key="2" tab="特安码平台">
              <div style="background-color: #ecf5ff;">
                <a-row>
                  <a-col :md="14">
                    <div style="width: 80%;float: right;padding-top: 8%;text-align:center;">
                      <p style="color: #404040;font-size: 28px;font-family: SourceHanSansSC-regular;font-weight: bold">特种设备安全码综合服务平台</p>
                      <p style="color:#233D63;font-size: 20px;">结合云平台、物联网、无线通信和数据分析等技术，提供特种设备信息化管理相关功能。</p>
                    </div>
                  </a-col>
                  <a-col :md="8">
                    <img src="~@/assets/imgs/tamcm.png" width="320" style="margin-top: 2%;"/>
                  </a-col>
                </a-row>
              </div>
            </a-tab-pane>
            <a-tab-pane key="3" tab="特种设备中台">
              <a-row>
                <a-col :md="14">
                  <div style="width: 80%;float: right;padding-top: 8%;text-align: center">
                    <p style="color: #404040;font-size: 28px;font-family: SourceHanSansSC-regular;font-weight: bold">特种设备信息化中台</p>
                    <p style="color:#233D63;font-size: 20px;">通过建立特种设备技术中台能力，支持电梯公共服务、维保信息登记、检测信息登记、按需维保申请等业务场景，辅助日常运行管理。</p>
                  </div>
                </a-col>
                <a-col :md="8">
                  <img src="~@/assets/imgs/ztcm.png" width="320" style="margin-top: 2%;"/>
                </a-col>
              </a-row>
            </a-tab-pane>
            <a-tab-pane key="4" tab="公共安全平台">
              <div style="background-color: #ecf5ff;">
                <a-row>
                  <a-col :md="14">
                    <div style="width: 80%;float: right;padding-top: 8%;text-align:center;">
                      <p style="color: #404040;font-size: 28px;font-family: SourceHanSansSC-regular;font-weight: bold">公共安全服务平台</p>
                      <p style="color:#233D63;font-size: 20px;">建立特种设备基础档案信息库，对设备采集的数据进行多维度分析，为不同类型用户提供适配功能，支持管理协同与业务联动。</p>
                    </div>
                  </a-col>
                  <a-col :md="8">
                    <img src="~@/assets/imgs/elcmz.png" width="320" style="margin-top: 2%;"/>
                  </a-col>
                </a-row>
              </div>
            </a-tab-pane>
            <a-tab-pane key="5" tab="镜面云码">
              <a-row>
                <a-col :md="14">
                  <div style="width: 80%;float: right;padding-top: 8%;text-align: center">
                    <p style="color: #404040;font-size: 28px;font-family: SourceHanSansSC-regular;font-weight: bold">镜面云码</p>
                    <p style="color:#233D63;font-size: 20px;">我司研发镜面云码方案，在普通二维码基础上增加多重校验能力，提升特种设备信息的可追溯性与一致性。</p>
                  </div>
                </a-col>
                <a-col :md="8">
                  <img src="~@/assets/imgs/jmcm.png" width="320"/>
                </a-col>
              </a-row>
            </a-tab-pane>
          </a-tabs>
        </div>
      </a-col>
      <a-col :md="24">
        <div style="height: 500px;background-color: #ecf5ff;text-align: center;margin-top: 20px;">
          <div style="color:#222A41;font-size: 24px;font-weight: bold;padding: 5% 0px">核心技术优势</div>
          <a-row>
            <a-col :md="6"></a-col>
            <a-col :md="18">
              <div style="width: 68%;">
                <p style="color:#222A41;font-size:18px;font-weight: bold;text-align: left">多重校验</p>
                <p style="color:#101010;font-size:14px;opacity: 0.5;text-align: left">自研云码方案结合多重校验机制，提升特种设备信息的可追溯性与一致性</p>
              </div>
            </a-col>
            <a-col :md="6"></a-col>
            <a-col :md="18">
              <div style="width: 68%;">
                <p style="color:#222A41;font-size:18px;font-weight: bold;text-align: left">数据核验</p>
                <p style="color:#101010;font-size:14px;opacity: 0.5;text-align: left">通过多系统数据比对与分析，辅助开展数据核验与归集，减少信息孤岛 </p>
              </div>
            </a-col>
            <a-col :md="6"></a-col>
            <a-col :md="18">
              <div style="width: 68%;">
                <p style="color:#222A41;font-size:18px;font-weight: bold;text-align: left">数据分析能力</p>
                <p style="color:#101010;font-size:14px;opacity: 0.5;text-align: left">围绕关键运行节点开展数据分析，结合行业经验与模型能力支持跨库多维度计算 </p>
              </div>
            </a-col>
          </a-row>
        </div>
      </a-col>
      <a-col :md="24">
        <foot-boot1 />
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import footBoot1 from './footboot1'
  export default {
    name: 'Website',
    components: {
      footBoot1
    },
    data () {
      return {
        scaleW: 1,
        scaleH: 1,
        size:50,
        tabBarGutter:60
      }
    },
    created(){

    },
    methods: {

    }
  }
</script>
<style>
  .anchorBL {
    display: none;
  }
  .BMap_cpyCtrl .BMap_noprint .anchorBL {
    display: none;
  }
</style>
<style scoped>
  a{
    white-space: nowrap;
    color: black;
    font-family: SourceHanSansSC-regular;
    margin-right:5%;
  }
  a:hover{
    color: black;
    font-weight: bold;
  }
  .allbody{
    width: 100%;
    transform-origin: left top;
    text-overflow:ellipsis;
    overflow:hidden;
    white-space:nowrap;
  }
  .allbody img{
    width: 140px;
    height: 30px;
  }
  .contant{
    height: 300px;
    background-color: #3B43F2;
    margin-top: 4%;
    text-align: center;
    padding-top: 6%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Productintr.vue